import type { Me } from '@/entities'
import type { Permission } from './permissions'
import { ROLE_PERMISSIONS } from './rolePermissions'

/**
 * Función pura: ¿este usuario tiene este permiso?
 *
 * Resuelve sumando los permisos de TODOS los roles del usuario. Si el usuario
 * tiene varios roles, gana el más permisivo.
 */
export function can(user: Me | null | undefined, permission: Permission): boolean {
  if (!user) return false
  for (const role of user.roles) {
    const perms = ROLE_PERMISSIONS[role.name]
    if (perms && perms.includes(permission)) return true
  }
  return false
}

export function canAny(user: Me | null | undefined, permissions: readonly Permission[]): boolean {
  return permissions.some((p) => can(user, p))
}

export function canAll(user: Me | null | undefined, permissions: readonly Permission[]): boolean {
  if (permissions.length === 0) return true
  return permissions.every((p) => can(user, p))
}
